import { render, staticRenderFns } from "./newMap1.vue?vue&type=template&id=29246a22&scoped=true&"
import script from "./newMap1.vue?vue&type=script&lang=js&"
export * from "./newMap1.vue?vue&type=script&lang=js&"
import style0 from "./newMap1.vue?vue&type=style&index=0&id=29246a22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29246a22",
  null
  
)

export default component.exports